






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EAutoPayItemStatus } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusAutoPaymentItem extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }
    switch (this.$props.status) {
      case EAutoPayItemStatus.PAID:
        return EStatusType.success
      case EAutoPayItemStatus.NEEDS_REVIEW:
        return EStatusType.attention
      case EAutoPayItemStatus.NO_BALANCE:
      case EAutoPayItemStatus.SKIPPED:
        return EStatusType.pending
      case EAutoPayItemStatus.SCHEDULED:
      case EAutoPayItemStatus.UPCOMING:
        return EStatusType.process
      case EAutoPayItemStatus.DELETED:
      case EAutoPayItemStatus.DECLINED:
        return EStatusType.error
      case EAutoPayItemStatus.DEACTIVATED:
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return AUTO_PAYMENT_ITEM_STATUSES_LABEL_MAP[this.$props.status]
  }
}
